/**
 * LE NOM D'UN MODÈLE DE DROITS — partagé par Opérateurs & droits et Référentiels › Remises.
 * ⚠️ Le nom donné par le magasin est une donnée et ne se traduit pas ; celui de l'éditeur est notre texte et se traduit.
 */
import { RIGHT_TEMPLATES } from '@orgazone/sync-contract';
import type { RightsTemplateView } from './api';
import { t } from './i18n';

/** Le nom d'un modèle : celui que le magasin lui a donné, sinon celui de l'éditeur, traduit. */
export function templateName(tpl: Pick<RightsTemplateView, 'label' | 'base'>): string {
  return tpl.label ?? t(RIGHT_TEMPLATES.find((x) => x.key === tpl.base)!.label);
}
